var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.ref && _vm.$store.state.ref.travelerTypes)?_c('ul',{staticClass:"traveler-type-picker"},_vm._l((_vm.$store.state.ref.travelerTypes),function(travelerType){return _c('li',{key:travelerType.id,class:{
      selected: _vm.value.indexOf(travelerType.id) > -1,
      selectedTour: _vm.selectText == 'selectedTour',
      selectedEvent: _vm.selectText == 'selectedEvent',
      selectStories: _vm.selectText == 'selectStories',
    },on:{"click":function($event){return _vm.onClick(travelerType)}}},[_vm._v(" "+_vm._s(travelerType.title)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }